import { Grid } from "@mui/material";

import React, { useMemo, useRef } from "react";
import ParentCard from "../shared/ParentCard";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const RouteMap = () => {
  const myElementRef = useRef(null);

  // Load the map only when the page is loaded
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "",
  });

  //disable default UI and clickable icons on map
  const mapOptions = useMemo(
    () => ({
      //   mapId: "76ad6d21487a0739",
      // disableDefaultUI: true,
      clickableIcons: false,
    }),
    []
  );

  const center = useMemo(() => ({ lat: 18.52043, lng: 73.856743 }), []);

  // Custom marker for the vehicle
  //   const customMarker = {
  //     path: "M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759   c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z    M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713   v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336   h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805",
  //     fillColor: "red",
  //     fillOpacity: 2,
  //     strokeWeight: 1,
  //     rotation: 0,
  //     scale: 1,
  //   };

  // Style for the map container
  const mapContainerStyle = useMemo(
    () => ({
      width: "100%",
      height: "90vh",
      borderRadius: "10px",
    }),
    []
  );

  return (
    <>
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              gap: 2,
            }}
          >
            <Grid container spacing={3}>
              <Grid
                item
                sm={12}
                ref={myElementRef}
                sx={{ position: "relative" }}
              >
                {!isLoaded ? (
                  <h1>Loading...</h1>
                ) : (
                  <>
                    <GoogleMap
                      options={mapOptions}
                      mapContainerStyle={mapContainerStyle}
                      center={center}
                      zoom={10}
                    >
                      <Marker
                        position={center}
                        // icon={customMarker}
                      />
                    </GoogleMap>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ParentCard>
    </>
  );
};

export default RouteMap;
